import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { projectConfig } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GamificationCardsService {
  public apiURL: string = projectConfig.apiURL;

  constructor(private http: HttpClient) {}

  getTrendingPrompts() {
    const url = this.apiURL + 'gamification/get_top_trending_prompts';
    return this.http.get<any>(url);
  }

  getTrendingConsumers() {
    const url = this.apiURL + 'gamification/get_top_trending_consumers';
    return this.http.get<any>(url);
  }

  getTrendingCreators() {
    const url = this.apiURL + 'gamification/get_top_trending_creators';
    return this.http.get<any>(url);
  }

  getTrendingCurators() {
    const url = this.apiURL + 'gamification/get_top_trending_curators';
    return this.http.get<any>(url);
  }

  getPromptCount(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });

    return this.http.post<any>(
      `${this.apiURL}gamification/get_prompts_count`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getTotalCategoriesCount(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });

    return this.http.post<any>(
      `${this.apiURL}gamification/get_total_categories_count`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getTotalUsage(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });
    return this.http.post<any>(
      `${this.apiURL}gamification/get_total_usage`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getAverageTimeSaved(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });

    return this.http.post<any>(
      `${this.apiURL}gamification/get_average_time_saved`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getTotalUsersCount(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });

    return this.http.post<any>(
      `${this.apiURL}gamification/get_total_users_count`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getAverageRating(categoryId: number[], sub_categoryId: number[]) {
    const bodyRequest = JSON.stringify({
      categories: categoryId,
      subcategories: sub_categoryId,
    });

    return this.http.post<any>(
      `${this.apiURL}gamification/get_average_rating`,
      bodyRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getMostUsedPrompts(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_most_used_prompts';
    return this.http.post<any>(url, payload, { params });
  }

  getMostTrendingPrompts(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_most_trending_prompts';
    return this.http.post<any>(url, payload, { params });
  }
  
  getCuratorList(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_curator_list';
    return this.http.post<any>(url, payload, { params });
  }

  getPowerUsers(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_power_users';
    return this.http.post<any>(url, payload, { params });
  }

  getTopCategories(params: HttpParams): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_categories';
    return this.http.get<any>(url, { params });
  }

  getTop3Users(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_3_users';
    return this.http.post<any>(url, payload, { params });
  }
  getTop3Creators(params: HttpParams, payload:any): Observable<any> {
    const url = this.apiURL + 'gamification/get_top_3_creators';
    return this.http.post<any>(url, payload, { params });
  }
  
}
